/**
 * Reduce an `analyze_document` JSON result envelope to a short customer-facing
 * markdown summary. Returns `null` when the payload is unparseable so the
 * caller can fall back to the raw summary renderer.
 */
export function summarizeAnalyzeDocumentResult(summary: string): string | null {
	try {
		const j = JSON.parse(summary) as {
			findings?: unknown[];
			notes?: unknown;
			source_file_name?: string;
			success?: boolean;
			error?: string;
		};
		const file = j.source_file_name ? `**${j.source_file_name}**` : "the document";
		if (j.success === false) {
			const msg = j.error || "could not be read.";
			return `Could not extract from ${file}: ${msg}`;
		}
		const count = Array.isArray(j.findings) ? j.findings.length : 0;
		const notes = Array.isArray(j.notes)
			? (j.notes as unknown[]).filter(
					(n): n is string => typeof n === "string" && n.trim() !== "",
				)
			: [];
		if (count === 0 && notes.length === 0) {
			return `Read ${file}; no findings extracted.`;
		}
		const parts = [`Read ${file} — ${count} ${count === 1 ? "finding" : "findings"}.`];
		if (notes.length) parts.push(...notes.map((n) => `- ${n}`));
		return parts.join("\n");
	} catch {
		return null;
	}
}
